import React from 'react';
import { Spinner } from 'reactstrap';

export const LoadingTable = () => {
    return(
    <div className='no-results-table'>
        <Spinner color="danger" />
    </div>
    )
}